<template>
  <div>
    <el-checkbox-group v-model="val" @change="$emit('change', $event)">
      <el-checkbox v-for="option in options"
                   :disabled="option['disabled']"
                   :key="option[valueAttr]"
                   :label="option[valueAttr]">{{ option[labelAttr] }}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {},
    options: {},
    labelAttr: {
      default: "name"
    },
    valueAttr: {
      default: "id"
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  watch: {
    value: function(value) {
      this.val = value;
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cx/cxCheckbox.vue